import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { persist, createJSONStorage } from 'zustand/middleware';
import moment from 'moment-jalaali';

const initialState = {
  drivers: null,
  startDate: moment(),
  endDate: moment(),
  page: 1,
  isLoading: false,
  totalDrivers: 0,
  selectedState: null,
};
export const useOnlineDriversStore = create(
  persist(
    immer((set, get) => ({
      ...initialState,
      setDrivers: (drivers) =>
        set((state) => {
          state.drivers = drivers;
        }),
      changeStartDate: (date) =>
        set((state) => {
          state.startDate = date;
        }),
      changeEndDate: (date) =>
        set((state) => {
          state.endDate = date;
        }),
      changePage: (page) =>
        set((state) => {
          state.page = page;
        }),
      changeLoading: (loading) =>
        set((state) => {
          state.isLoading = loading;
        }),
      setTotalDrivers: (data) =>
        set((state) => {
          state.totalDrivers = data;
        }),
      setSelectedState: (data) =>
        set((state) => {
          state.selectedState = data;
        }),
    })),
    {
      name: '@footab/admin/onlineDrivers',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(([key]) => !['drivers'].includes(key))
        ),
    }
  )
);
